/**
 * Freigabeliste Lieferant -> Zahlungsvorlage (Spec 2026-09-07, Abschnitt 3). GET ist fuer alle
 * Rollen offen, PUT verlangt manage_suppliers. Die Liste wird immer als Ganzes ersetzt.
 */
import { anfrage } from "./basis.ts";

export interface FreigabeZeile {
  kLieferant: number;
  templateId: string;
  isDefault: boolean;
  sortIndex: number;
  /** Beschriftung aus payment_templates - die Anzeige braucht den Katalog nicht nachzuladen. */
  label: string;
}

export interface FreigabeEingabe {
  templateId: string;
  isDefault: boolean;
}

export function ladeFreigaben(kLieferant: number, signal?: AbortSignal): Promise<FreigabeZeile[]> {
  return anfrage<FreigabeZeile[]>(`/api/suppliers/${kLieferant}/payment-terms`, { methode: "GET", signal });
}

export function freigabenErsetzen(
  kLieferant: number,
  eintraege: readonly FreigabeEingabe[],
): Promise<FreigabeZeile[]> {
  return anfrage<FreigabeZeile[]>(`/api/suppliers/${kLieferant}/payment-terms`, {
    methode: "PUT",
    koerper: { eintraege },
  });
}
